export default function AboutSection() {
  return (
    <section id="nosotros" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-[600px]">
                <img 
                  src="https://public.readdy.ai/ai/img_res/33fff68c066d05338ce4cdbfaa0f98f0.jpg"
                  alt="Conductor profesional WeBus Transporte Málaga"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>

            {/* Stats Card */}
            <div className="absolute -bottom-8 -right-8 bg-white rounded-2xl shadow-2xl p-8 max-w-xs">
              <div className="flex items-center space-x-4 mb-4">
                <div className="w-16 h-16 bg-teal-500 rounded-xl flex items-center justify-center">
                  <i className="ri-trophy-line text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">15+</div>
                  <div className="text-sm text-gray-600">Años de experiencia</div>
                </div>
              </div>
              <div className="flex items-center space-x-2 text-yellow-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <span className="text-gray-900 font-semibold ml-2">5.0</span>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-block bg-teal-50 rounded-full px-6 py-2 mb-6">
              <span className="text-teal-600 font-semibold text-sm">
                <i className="ri-information-line mr-2"></i>
                SOBRE NOSOTROS
              </span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Tu Socio de Confianza en <span className="text-teal-600">Transporte Premium</span>
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              <strong>WeBus Transporte Málaga</strong> es líder en servicios de transporte premium con microbús 
              en la Costa del Sol. Con más de 15 años de experiencia, ofrecemos soluciones de movilidad 
              excepcionales para grupos de 8 a 19 pasajeros.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}